import React from 'react';
import PropTypes from 'prop-types';
import StyledSessionDrawer from 'common/theme/session/drawer/StyledSessionDrawer';

/**
 * Panel derecho de sesiones = MISMO drawer OVERLAY de la Agenda (`StyledSessionDrawer`):
 * anchor right, se desliza ENCIMA del contenido con backdrop (surface.sidebar + hairline izq +
 * sombra; 400px en desktop, full en móvil). Lo usan el detalle (cliente), la asistencia
 * (admin/entrenador) y la lista filtrada al pulsar una card-counter. Mode-aware por tokens.
 */
function SessionDetailDrawer({ open, onClose, children }) {
  return (
    <StyledSessionDrawer anchor="right" open={open} onClose={onClose}>
      {children}
    </StyledSessionDrawer>
  );
}

SessionDetailDrawer.propTypes = {
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  children: PropTypes.node.isRequired
};

export default SessionDetailDrawer;
